<template>
  <h1>
    A crappy-performing vue-js implementation of John Conway's Game of Life
  </h1>
  <GameOfLife class="game-of-life" />
  <a
    target="_blank"
    href="https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life"
    >John Conway's Game Of Life (wikipedia)</a
  >
</template>

<script>
import GameOfLife from "./components/GameOfLife.vue";

export default {
  name: "App",
  components: {
    GameOfLife,
  },
};
</script>

<style lang="scss">
* {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  box-sizing: border-box;
}

#app {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}

html,
body {
  height: 100%;
  min-height: 100%;
}

h1 {
  margin-top: 0;
  font-size: 1.5em;
}
</style>
